import React from "react";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaWhatsapp,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";

const Footer = () => {
  return (
    <footer className="bg-dark text-white py-4">
      <div className="container">
        <div className="row">
          {/* Contact Us */}
          <div className="col-md-4 mb-3">
            <h5>Contact Us</h5>
            <p>Email: thekytslibrary@gmail.com</p>
            <p>Phone:+ 91 8884174000</p>
            <p>
              {
                //    WhatsApp:{" "}
                //    <a
                //      href="https://wa.me/919886423255"
                //      className="text-success"
                //      target="_blank"
                //      rel="noopener noreferrer"
                //    >
                //      <FaWhatsapp /> Chat with us
                //    </a>
              }
            </p>
          </div>

          {/* Address */}
          <div className="col-md-4 mb-3">
            <h5>Address</h5>
            <p>
              No.150, 1st floor,
              <br />
              Above fashion trends, RK Hegdenagar,
              <br />
              Dr.Sivram Karanth Nagar post, Bengaluru- 560077
              <br />
              Next to Bharat Petrol Bunk
            </p>
          </div>

          {/* Social Media Links */}
          <div className="col-md-4 mb-3">
            <h5>Follow Us</h5>
            <div className="d-flex">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white me-3"
                style={{ fontSize: "1.5rem" }}
              >
                <FaFacebook />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white me-3"
                style={{ fontSize: "1.5rem" }}
              >
                <FaTwitter />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white me-3"
                style={{ fontSize: "1.5rem" }}
              >
                <FaInstagram />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white"
                style={{ fontSize: "1.5rem" }}
              >
                <FaLinkedin />
              </a>
            </div>
          </div>
        </div>

        <hr className="bg-white" />

        {/* Copyright */}
        <div className="text-center">
          <p className="mb-0">&copy; 2025 Paupet Soft All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
